var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("h2", { staticClass: "header" }, [_vm._v("Kitty Generator")]),
      _vm._v(" "),
      _c("div", { staticClass: "intro" }, [
        _c("p", [
          _vm._v(
            "Kitty代码生成器，可以通过界面配置快速生成包括 model，dao，service，controller 以及页面的相关代码。"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("项目地址："),
          _c(
            "a",
            { attrs: { href: "https://gitee.com/liuge1988/kitty-generator" } },
            [_vm._v("https://gitee.com/liuge1988/kitty-generator")]
          ),
          _vm._v(
            "\n      , 项目使用指南如下图，具体环境搭建参考安装教程。\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "title" }, [_vm._v("使用指南")]),
        _vm._v(" "),
        _c("div", { staticClass: "step" }, [
          _c("span", [_vm._v("1.配置数据源")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "image" }, [
          _c("img", {
            staticClass: "usageImage",
            attrs: {
              src:
                "https://images.gitee.com/uploads/images/2018/1114/180145_1b395632_645970.png"
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "step" }, [
          _c("span", [_vm._v("2.选择数据库表")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "image" }, [
          _c("img", {
            staticClass: "usageImage",
            attrs: {
              src:
                "https://images.gitee.com/uploads/images/2018/1114/180317_ca91ceb2_645970.png"
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "step" }, [
          _c("span", [_vm._v("3.编辑信息，生成代码")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "image" }, [
          _c("img", {
            staticClass: "usageImage",
            attrs: {
              src:
                "https://images.gitee.com/uploads/images/2018/1114/180642_2c4f986d_645970.png"
            }
          })
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-243bf4ad", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-243bf4ad","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Generator/Generator.vue
// module id = null
// module chunks = 